import { request } from '@pb/utils'

export const initStoreActivation = (): any =>
  request.post('pay-later/init-activation').then((res) => res.data)

export const performStoreActivation = (token): any =>
  request
    .post('pay-later/perform-activation', {
      data: {
        token,
      },
    })
    .then((res) => res.data)

export const fetchStoreActivationInfo = (): any =>
  request
    .get('customer-service/omnicreditoptin', {
      type: 'adobe',
    })
    .then((res) => res.data)
